import {useCallback, useEffect, useRef} from 'react';
import {createReadAcknowledgement} from '../readAcknowledgement';

export default function useReadAcknowledgement(scope, write, refresh, report, enabled = true) {
    const latest = useRef({write, refresh, report});
    latest.current = {write, refresh, report};
    const active = useRef(null);
    useEffect(() => {
        if (!enabled) return;
        const controller = new AbortController();
        const queue = createReadAcknowledgement(target => latest.current.write(target, controller.signal),
            result => {
                if (result?.event_id !== undefined) {
                    const [actorId, conversationId, rootId] = scope.split(':').map(Number);
                    window.dispatchEvent(new CustomEvent('chat-read-confirmed', {detail: {...result, actor_id: actorId, conversation_id: conversationId, root_message_id: rootId}}));
                    return;
                }
                return latest.current.refresh();
            }, error => latest.current.report(error), {intervalMs: 2000, retryTransient: true});
        active.current = {scope, queue};
        return () => { queue.dispose(); controller.abort(); active.current = null; };
    }, [scope, enabled]);
    return useCallback((target, options) => active.current?.scope === scope
        ? active.current.queue.request(target, options) : Promise.resolve(), [scope]);
}
